import React, { Component } from 'react'
import { match, RouteComponentProps } from 'react-router'
import withNavbar from '../../common/HOC/NavbarContainerHOC'
import UpdateFormDetail from './SettingForm'

interface MatchParams {
    id: string;
}

interface Props extends RouteComponentProps<MatchParams>{
    match:match<MatchParams>;
}
interface State {
}

class Setting extends Component<Props, State> {
    state = {}

    componentDidMount(){
    }

    render() {
        return (
            <div className="card">
                <div className="card-title1">Cấu hình hệ thống</div>
                <div className="card-body">
                    <UpdateFormDetail history={this.props.history}/>
                </div>
            </div>
        )
    }
}

const updateWithNavBar = withNavbar()(Setting);

export default updateWithNavBar;

